import Styled from 'styled-components'

export const Container = Styled.div`
`

export const H1 = Styled.h1`
`
export const Line = Styled.div`
`

export const Information = Styled.div`
`

export const P = Styled.p`
`

export const Span = Styled.span`
`